    <form  class="flex flex-col gap-5 "  [formGroup]="form" >

        <div class="" >
            <div class="flex flex-col gap-5 ">

                <div class="relative flex flex-col bg-card rounded-lg py-2.5 px-4">
                    <div class="flex flex-row gap-1">
                        <select formControlName="currency"  class="text-normal  rounded-lg  h-fit p-2.5 bg-card  placeholder-gray-400  focus:ring-primary  text-sm font-bold " (change)="changeCurrency($event)">
                            <option *ngFor="let item of selectCurrenciesOptions" [value]="item.value" class="bg-transparent text-normal">
                                {{item.label | translate}}
                            </option>
                        </select>
                        <div class="flex-1">
                            <app-input
                                    [type]="'number'"
                                    [formControlItem]="form.controls['price']"
                                    [labelClass]="'!text-start'"
                                    [placeholder]="'0.00'"
                                    [min]="setPrices[0]"
                                    [customClasses] = "'!border-none !ring-0 text-sm font-normal !p-0 focus:outline-none'"
                            ></app-input>
                        </div>
                    </div>
                    <div class="flex flex-row gap-1 w-full justify-end">
                        @for (item of setPrices; track $index){
                            <a
                                    (click)="selectMoney(item)"
                                    class=" flex text-xs w-fit items-center justify-center rounded-md border border-transparent bg-primary px-2.5 py-2 font-medium text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
                            >
                                {{item | currency: form.controls['currency'].value}}
                            </a>
                        }

                    </div>

                </div>
            </div>

        </div>


        <div class="flex flex-col gap-2">
            <a
                    (click)="donate('donate')"
                    class=" flex w-full items-center justify-center rounded-md border border-transparent bg-primary px-8 py-3 text-base font-medium text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
            >
                {{ 'donate'| translate }}
            </a>
<!--            @if (stickersEnabled){-->
<!--                <a-->
<!--                        (click)="donate('sticker')"-->
<!--                        class="flex w-full items-center justify-center rounded-md border border-primary bg-transparent px-8 py-3 text-base font-medium text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"-->
<!--                >-->
<!--                    {{ 'sticker'| translate }}-->
<!--                </a>-->
<!--            }-->

            @if (notifications && notifications.length){
                @for (item of notifications; track $index) {
                    @if (item.displayButtonText){
                        <a (click)="donate('notification', item)" class="flex w-full items-center justify-center rounded-md border border-primary bg-transparent px-8 py-3 text-base font-medium text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer">
                            {{ item.displayButtonText }}
                        </a>
                    }

                }
            }
            @if (crowdfundings && crowdfundings.length){
                @for (item of crowdfundings; track $index) {
                    <a (click)="donate('crowdfunding', item)"
                       [ngStyle]="{
                        'background': item.styles.filledColor
                       }"
                       class="flex w-full items-center justify-center rounded-md border-0 opacity-90 hover:opacity-100 shadow-primary bg-success px-8 py-3 text-base font-medium text-normal hover:bg-success-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer">
                        <span class="text-white">
                            {{ item.title }} ({{Math.ceil((item.collectedMoney / item.targetValue) * 100)}}%)
                        </span>

                    </a>
                }
            }
            @if (customDonations && customDonations.length){
                @for(button of customDonations; track $index){
                    <white-label-donation-widget-button
                            [customButtonStyles]="button"
                            (onClick)="donate(button.type|| 'trigger', button)"
                    >
                    </white-label-donation-widget-button>
                }
            }
        </div>
    </form>
